import { Component, inject } from '@angular/core';
import { ButtonComponent } from '../../ui/button/button.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-not-found',
  imports: [ButtonComponent],
  template: `
    <div
      class="flex flex-col items-center justify-center h-screen bg-gray-50 gap-6"
    >
      <div class="flex flex-col items-center gap-2 px-4">
        <p
          class="text-5xl sm:text-6xl md:text-7xl font-bold text-gray-900 text-center"
        >
          404
        </p>
        <p
          class="text-3xl sm:text-4xl md:text-5xl font-semibold text-gray-800 text-center"
        >
          Tražena stranica ne može biti prikazana
        </p>
        <p class="text-xl sm:text-2xl md:text-3xl text-gray-900 text-center">
          Link koji ste upotrebili nije validan
        </p>
        <p class="text-gray-500 text-md sm:text-lg font-medium text-center">
          ili je stranica nedostupna
        </p>
      </div>
      <app-button
        title="Nazad na početnu"
        icon="heroHome"
        (handleClick)="onHome()"
      ></app-button>
    </div>
  `,
})
export class PageNotFoundComponent {
  router = inject(Router);
  onHome() {
    this.router.navigate(['/']);
  }
}
